import type { ReactNode } from 'react';
import { Box, Flex } from '@mantine/core';

type BoardsLayoutProps = {
  children: ReactNode;
};

export const BoardsLayout = ({ children }: BoardsLayoutProps) => {
  return <Flex gap="xl">{children}</Flex>;
};

type BoardsLayoutSidebarProps = {
  children: ReactNode;
};

export const BoardsLayoutSidebar = ({ children }: BoardsLayoutSidebarProps) => {
  return <Box>{children}</Box>;
};

type BoardsLayoutContentProps = {
  children: ReactNode;
};

export const BoardsLayoutContent = ({ children }: BoardsLayoutContentProps) => {
  return <Box sx={theme => ({ flex: 1 })}>{children}</Box>;
};
